import filter from 'lodash/filter';
import { dataFilter, filterByMarket } from '../../helpers';

const getDataFilters = ({ wine, network }) => [
  { value: wine, key: 'wine_name', default: [] },
  { value: network, key: 'network_code', default: [] }
];

const filterByVintages = ({ data, vintageStart, vintageEnd }) =>
  filter(
    data,
    (wine) =>
      (!isNaN(Number(wine.vintage)) || wine.vintage.toLowerCase() === 'nv') &&
      (!vintageStart || vintageStart <= Number(wine.vintage)) &&
      (!vintageEnd || vintageEnd >= Number(wine.vintage))
  );

const applyFiltersToData = ({
  data,
  wine,
  market,
  network,
  activeRadioButton,
  vintageStart,
  vintageEnd
}) => {
  let filteredData = dataFilter(data, getDataFilters({ wine, network }));
  filteredData = filterByMarket(
    filteredData,
    market,
    'vintage',
    activeRadioButton
  );
  filteredData = filterByVintages({
    data: filteredData,
    vintageStart,
    vintageEnd
  });
  return filteredData;
};

const getChartData = ({
  data,
  wine,
  market,
  network,
  activeRadioButton,
  vintageStart,
  vintageEnd,
  competitor,
  currency
}) => {
  const wineData = applyFiltersToData({
    data,
    wine,
    market,
    network,
    activeRadioButton,
    vintageStart,
    vintageEnd
  });

  const competitorData = competitor
    ? [
        applyFiltersToData({
          data,
          wine: competitor,
          market,
          network,
          activeRadioButton,
          vintageStart,
          vintageEnd
        })
      ]
    : [];

  return transformDataForChart({
    data: [wineData, ...competitorData],
    currency
  });
};

const transformDataForChart = ({ data, currency }) => {
  // Transform item function
  const transformItemFunction = (item) => {
    const useLocalPrice = currency && currency !== item.displayed_currency;
    return {
      ...item,
      name: item.vintage,
      minPrice: {
        icon: 'negative',
        currency: useLocalPrice ? item.local_currency : item.displayed_currency,
        value: useLocalPrice ? item.min_local_price : item.min_price
      },
      value: {
        icon: 'neutral',
        currency: useLocalPrice ? item.local_currency : item.displayed_currency,
        value: useLocalPrice ? item.avg_local_price : item.avg_price
      },
      maxPrice: {
        icon: 'positive',
        currency: useLocalPrice ? item.local_currency : item.displayed_currency,
        value: useLocalPrice ? item.max_local_price : item.max_price
      }
    };
  };

  // Create formatted data
  let formattedData = data.map((set) =>
    set.map((item) => transformItemFunction(item))
  );

  // Sort formatted data by names
  formattedData.forEach((set) =>
    set.sort((a, b) => String(a.name).localeCompare(String(b.name)))
  );

  // Create unique sorted list of names
  const setNames = [
    ...new Set(formattedData.flatMap((set) => set.map((item) => item.name)))
  ].sort((a, b) => String(a).localeCompare(String(b)));

  // Create list of wines (index of wine name is the same as index of set)
  let wines = formattedData
    .map((set) => (set && set.length > 0 ? set[0].wine_name : null))
    .filter((item) => item);

  // Fill missing values (prices) with null values
  formattedData.forEach((set, setIndex) => {
    setNames.forEach((name, index) => {
      if (!set[index] || set[index].name !== name) {
        set.splice(index, 0, {
          name,
          value: 0,
          wine_name: wines[setIndex]
        });
      }
    });
  });
  return formattedData;
};

export { getDataFilters, getChartData };
